import script from "./PUR04_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR04_001INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR04_001INS.vue?vue&type=style&index=0&id=ed01999e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed01999e"]])

export default __exports__